import React from "react";
import {
  Grid,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import EditIcon from "@mui/icons-material/Edit";

import {
  CustomSecondaryEditButton,
  CustomSecondaryDownLoadButton,
  CustomSecondaryButton,
  CustomSuccessButton,
} from "../../../../../Global_Component/GlobalButtonComponent";

const MeatList3 = () => {
  const procurementData = [
    {
      id: 1,
      particular: "Marinated or Prepared Meats:",
      category: "Deli Meats (e.g., ham, turkey, roast beef)",
      subCategory: "Fresh farm",
      quantity: 30,
      supplierName: "Aslam Khan",
      pocName: "Aslam Khan",
      pocContactNumber: "Aslam Khan",
    },
    {
      id: 2,
      particular: "Marinated or Prepared Meats:",
      category: "Deli Meats (e.g., ham, turkey, roast beef)",
      subCategory: "Fresh farm",
      quantity: 30,
      supplierName: "Aslam Khan",
      pocName: "Aslam Khan",
      pocContactNumber: "Aslam Khan",
    },
    {
      id: 3,
      particular: "Marinated or Prepared Meats:",
      category: "Deli Meats (e.g., ham, turkey, roast beef)",
      subCategory: "Fresh farm",
      quantity: 30,
      supplierName: "Aslam Khan",
      pocName: "Aslam Khan",
      pocContactNumber: "Aslam Khan",
    },
  ];

  return (
    <Box sx={{ padding: "16px" }}>
      <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: "bold" }}>
          Meat Procurement List
        </Typography>
        <Box>
          <CustomSecondaryDownLoadButton sx={{ mr: 1 }} label={"Download"} />
          <CustomSecondaryEditButton sx={{ mr: 1 }} label={"Edit"} />
        </Box>
      </Grid>

      <TableContainer sx={{ border: "1px solid #ddd", borderRadius: "8px" }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#F9FAFC" }}>
              <TableCell sx={{ fontWeight: "500" }}>SL No.</TableCell>
              <TableCell sx={{ fontWeight: "500" }}>Particular</TableCell>
              <TableCell sx={{ fontWeight: "500" }}>Category</TableCell>
              <TableCell sx={{ fontWeight: "500" }}>Sub-Category</TableCell>
              <TableCell sx={{ fontWeight: "500" }}>Qty (kgs/per day)</TableCell>
              <TableCell sx={{ fontWeight: "500" }}>Supplier Name</TableCell>
              <TableCell sx={{ fontWeight: "500" }}>POC Name</TableCell>
              <TableCell sx={{ fontWeight: "500" }}>POC Contact Number</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {procurementData.map((item, index) => (
              <TableRow key={item.id}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{item.particular}</TableCell>
                <TableCell>{item.category}</TableCell>
                <TableCell>{item.subCategory}</TableCell>
                <TableCell>{item.quantity}</TableCell>
                <TableCell>{item.supplierName}</TableCell>
                <TableCell>{item.pocName}</TableCell>
                <TableCell>{item.pocContactNumber}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Grid
        xs={12}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 1,
          my: 2,
        }}
      >
        <CustomSecondaryButton label={"Back"} />
        <CustomSuccessButton label={"Approve & Continue"} />
      </Grid>
    </Box>
  );
};

export default MeatList3;
